// removed by extract-text-webpack-plugin
module.exports = {"successBanner":"successBanner__HUFsA","errorBanner":"errorBanner__nxXb3"};


//////////////////
// WEBPACK FOOTER
// ./components/partial/layers/snackBar/style.css
// module id = sNCy
// module chunks = 446